import type { InjectionKey, WritableComputedRef } from 'vue'
import type { Elemental } from '~~/src/types/elemental'

interface IPromptState {
  prompt?: WritableComputedRef<Elemental | null>
}
export const promptInjectKey = Symbol('promptInjectKey') as InjectionKey<IPromptState>
